module.exports = __webpack_public_path__ + "images/moonshot/exclusive-offer.8e3eb159bf369aba22ec.png";